// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"86":"ee66bafffaa4414447c5","728":"9f96bdc52b5e36a5d122"}[chunkId] + ".js";
};